/**
 * Product View Modes — constants for all available visualization modes in ProductView
 * Corresponds to layout schema in panel settings; used by mode registry and UI controls
 */
import { InfoMode }        from '../../../shared/ui/icons/InfoMode.jsx'
import { HotspotMode }     from '../../../shared/ui/icons/HotspotMode.jsx'
import { InsolationMode }  from '../../../shared/ui/icons/InsolationMode.jsx'
import { ArrangeMode }     from '../../../shared/ui/icons/ArrangeMode.jsx'
import { AxonometricMode } from '../../../shared/ui/icons/AxonometricMode.jsx'

/**
 * Product View Modes — exclusive visualization modes for the plan viewer.
 *
 * These are the main modes users can switch between. Each mode can be rendered
 * in different viewer variants (2D, 3D), but the variant is orthogonal to the mode.
 * Variant support per mode is defined in the mode registry.
 */
export const PRODUCT_VIEW_MODE = {
  INFO: 'info',
  ARRANGE: 'arrange',
  HOTSPOT: 'hotspot',
  INSOLATION: 'insolation',
  AXONOMETRIC: 'axonometric',
}

export const PRODUCT_VIEW_MODE_LABEL_KEYS = {
  [PRODUCT_VIEW_MODE.INFO]: 'product.mode_info',
  [PRODUCT_VIEW_MODE.ARRANGE]: 'product.mode_arrange',
  [PRODUCT_VIEW_MODE.HOTSPOT]: 'product.mode_hotspot',
  [PRODUCT_VIEW_MODE.INSOLATION]: 'product.mode_insolation',
  [PRODUCT_VIEW_MODE.AXONOMETRIC]: 'product.mode_axonometric',
}

/**
 * Product View Mode Icons — maps each product view mode ID to its icon component.
 *
 * Icon components accept standard SVG props (width, height, className, style).
 * Modes without an entry receive no icon; the toggle falls back to the label.
 */

export const PRODUCT_VIEW_MODE_ICONS = {
  [PRODUCT_VIEW_MODE.INFO]:        InfoMode,
  [PRODUCT_VIEW_MODE.HOTSPOT]:     HotspotMode,
  [PRODUCT_VIEW_MODE.INSOLATION]:  InsolationMode,
  [PRODUCT_VIEW_MODE.ARRANGE]:     ArrangeMode,
  [PRODUCT_VIEW_MODE.AXONOMETRIC]: AxonometricMode,
}

/**
 * Default mode order — fallback if not specified in panel settings
 */
export const PRODUCT_VIEW_MODE_DEFAULT_ORDER = [
  PRODUCT_VIEW_MODE.INFO,
  PRODUCT_VIEW_MODE.HOTSPOT,
  PRODUCT_VIEW_MODE.INSOLATION,
  PRODUCT_VIEW_MODE.ARRANGE,
  PRODUCT_VIEW_MODE.AXONOMETRIC,
]

/**
 * All available modes in registry
 */
export const ALL_PRODUCT_VIEW_MODES = Object.values(PRODUCT_VIEW_MODE)
